import { diagnosticLog } from '../utils/diagnosticLogger';

export type DeviceStopOptions = {
  caller: string;
  /** True only for explicit user gestures (button, keyboard shortcut, lock-screen). */
  userInitiated?: boolean;
};

const INTERNAL_DEVICE_STOP_CALLERS = new Set([
  'queue_terminal_network_renderer',
]);

export function maySendDeviceStop(opts: DeviceStopOptions): boolean {
  if (opts.userInitiated) return true;
  if (INTERNAL_DEVICE_STOP_CALLERS.has(opts.caller)) return true;
  diagnosticLog('warn', 'js:transport', 'device_stop_blocked', {
    caller: opts.caller,
    userInitiated: false,
  });
  return false;
}

export function deviceStopAllowed(stopOpts?: DeviceStopOptions): DeviceStopOptions | null {
  const opts = stopOpts ?? { caller: 'unlabeled_stop_renderer', userInitiated: false };
  return maySendDeviceStop(opts) ? opts : null;
}
